import { Injectable } from '@nestjs/common';
import { ShippingTerms } from '../shipping-terms.entity';
import { ShippingTermsDTO } from './shipping-terms.dto';

@Injectable()
export class ShippingTermsAdapter {
  /**
   *
   * @param ShippingTermsDto
   * @returns ShippingTerms entity
   */
  public convertDtoToEntity(  ShippingTermsDTO: ShippingTermsDTO,  isUpdate: boolean = false ): ShippingTerms {
    const shippingTerms = new ShippingTerms();
    shippingTerms.shippingTermsId=ShippingTermsDTO.shippingTermsId;
    shippingTerms.shippingTermsName=ShippingTermsDTO.shippingTermsName;
    shippingTerms.isActive=ShippingTermsDTO.isActive==undefined?true:ShippingTermsDTO.isActive;
    if (isUpdate) {
      shippingTerms.updatedUser = ShippingTermsDTO.updatedUser;
    } else {
      shippingTerms.isActive = true;
      shippingTerms.createdUser = ShippingTermsDTO.createdUser;
    }
   return shippingTerms;
  }
  public convertEntityToDto(shippingTermsObject: ShippingTerms): ShippingTermsDTO {
    const shippingTermsDTO= new ShippingTermsDTO;
    shippingTermsDTO.shippingTermsId = shippingTermsObject.shippingTermsId;
    shippingTermsDTO.shippingTermsName = shippingTermsObject.shippingTermsName;
    shippingTermsDTO.isActive = shippingTermsObject.isActive;
    shippingTermsDTO.createdAt = shippingTermsObject.createdAt;
    shippingTermsDTO.updatedAt = shippingTermsObject.updatedAt;
    shippingTermsDTO.createdUser = shippingTermsObject.createdUser;
    shippingTermsDTO.updatedUser = shippingTermsObject.updatedUser;
    shippingTermsDTO.versionFlag = shippingTermsObject.versionFlag;
    return shippingTermsDTO;
  }
}
